@if (tiles$ | async; as tiles) {
  @if (isMobile$ | async) {
    @for (tile of tiles; track tile.id) {
      <div class="mb-3">
        <app-router-link
          [route]="Route.PL_BrandDetails"
          [params]="routerLinkParams(tile.slug)"
          queryParamsHandling="preserve">
          {{ tile.name }}
        </app-router-link>
      </div>
    }
  } @else {
    <div class="flex flex-wrap justify-center">
      @for (tile of tiles; track tile.id) {
        <app-router-link
          [route]="Route.PL_BrandDetails"
          [params]="routerLinkParams(tile.slug)"
          queryParamsHandling="preserve">
          <app-public-brand-tile
            [name]="tile.name"
            [logoAlt]="tile.logoAlt"
            [logoSrc]="tile.logoSrc" />
        </app-router-link>
      }
    </div>
  }
} @else {
  <app-spinner-filled />
}
